import { EventHandler } from "../../HelperFunctions/index.js";
import { ModelBase } from "../ModelBase.js";
import { HashedDaySchedule } from "./HashBasedScheduleTracker.js";

export class IrrigationEventProto extends ModelBase {
    /**
     * Describes whether this event comes from a repeating event, a csv file, or a single event.
     * set means it is a meta event describing when a set is active
     * @type {"single" | "repeating" | "csv" | "set" }
     */
    type = "single";
    static onNewIrrigationEventProto = new EventHandler({}, 100);

    /**
     *
     * @param props
     * @param manualLoad if true, the load() function will need to be triggered manually.
     *
     */
    constructor(props, manualLoad = false, skip = true) {
        super(props, skip);
        this.category = "irrigationEvent";
        if (!manualLoad) {
            this.load().catch((e) => {
                console.warn(e);
            });
        }
    }

    /**
     *
     * @type {HashedDaySchedule}
     */
    currentHashEntry = undefined;
    async load() {
        // IrrigationEventProto.onNewIrrigationEventProto.trigger({ target: this }).catch((e) => {
        //     console.warn(e);
        // });

        if (this.type !== "repeating") {
            this.currentHashEntry = HashedDaySchedule.addEventToHashTable(this);
        }
        //await this.onLoad.trigger({ target: this, load: this });
        if (this._loadPromiseResoloution) {
            this._loadPromiseResoloution(0);
        }
    }

    /**
     * If this comes from a command group, what command group does it come from?
     * @type {undefined}
     */
    commandGroup = undefined;
    get root() {
        if (this.commandGroup) {
            return this.commandGroup;
        }
        return this;
    }
    /**
     * Time that event will start
     * @type {Date}
     */
    startTime = undefined;
    /**
     * @type {number} Milliseconds in duration
     */
    duration = undefined;
    /**
     * ID of the zone being assigned to
     * @type {String}
     */
    get zoneID() {
        if (this.zone) {
            return this.zone.dbID;
        } else {
            return undefined;
        }
    }

    /**
     * ZoneAPI object being assigned to
     * @type {Zone}
     */
    zone = undefined;

    async delete() {
        if (this.currentHashEntry) {
            this.currentHashEntry.removeEvent(this);
        }
        //
        // await super.delete();
        this.deleted = true;
    }

    dispose() {
        //super.dispose();
        this.startTime = new Date(0);
        this.duration = 0;
        this.zone = undefined;
    }

    get endTime() {
        return new Date(this.startTime.valueOf() + this.duration);
    }
}
